import { Component, Input, OnInit, ViewChild } from "@angular/core";
import {
  RequestState,
  RequestStateEnum,
} from "@app-module/shared/RequestState";
import { DashboardCardsService } from "@app-service/dashboard-cards.service";
import { ToasterService, ToasterType } from "@app-service/toaster.service";
import { UserService } from "@app-service/user.service";
import { ConfirmationModalService } from "@app/admin/confirmation-modal.service";
import { PopupLayoutComponent } from "@app/admin/confirmation-popup/popup-layout/popup-layout.component";
import { Subscription } from "rxjs";
import { NotifiedPopupComponent } from "../notified-popup/notified-popup.component";
import {
  TRANSCORP_TENANT_VALUE,
  tenantSetter,
} from "@app-common/http/interceptors/tenantType";

@Component({
    selector: "app-meal-card-employee-info",
    templateUrl: "./meal-card-employee-info.component.html",
    styleUrls: ["./meal-card-employee-info.component.scss"],
    standalone: false
})
export class MealCardEmployeeInfoComponent implements OnInit {
  private subscriptions: Subscription = new Subscription();
  submitRequestState: RequestState;
  @ViewChild("modal") modal: PopupLayoutComponent;

  @Input()
  title: string;

  constructor(
    public userService: UserService,
    private cardsDashboardService: DashboardCardsService,
    private toasterService: ToasterService,
    private confirmationModal: ConfirmationModalService
  ) {
    this.submitRequestState = RequestState.init();
  }

  formActionRequestState(): RequestStateEnum {
    return this.submitRequestState.state;
  }
  onSetup(): void {
    tenantSetter(TRANSCORP_TENANT_VALUE);
    this.submitRequestState.pending();
    this.subscriptions.add(
      this.cardsDashboardService.captureInterest("MEAL_CARD_REQUEST").subscribe(
        (res) => {
          this.submitRequestState.completed();

          this.modal.close();
          this.confirmationModal.showInformationalModal(
            NotifiedPopupComponent,
            {
              centered: true,
              scrollable: true,
            }
          );
        },
        (err) => {
          this.submitRequestState.rejected();
          this.toasterService.showToaster(
            err["error"]["payload"]
              ? err["error"]["payload"]
              : "Something went wrong",
            ToasterType.ERROR
          );
        }
      )
    );
  }
  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
